import React from "react";
// import Spline from "@splinetool/react-spline";
function SplineElement() {
    return (
        <div className="sp">
            {/* <Spline
                className="!hidden md:!flex "
                scene="https://prod.spline.design/ELos0TXWrbbSNK4P/scene.splinecode"
            /> */}
        </div>
    );
}

export default SplineElement;
